import {Box, CenterBox} from '@buncha/components/core/view';
import {H3Text, H6Text} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import BorderCrossIcon from '@buncha/components/core/icon/BorderCrossIcon';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

const CancelOrderHeader = () => {
  const theme = useColorThemeType();
  const mortiseFont = useFontTheme('mortise');
  const muliFont = useFontTheme();
  const {title, body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};

  return (
    <Box
      style={[styles.container, {backgroundColor: theme?.background.red[300]}]}>
      <CenterBox>
        <BorderCrossIcon
          width={scaleFonts(64)}
          height={scaleFonts(64)}
          viewBox="0 -1 16 16"
          fill={theme?.background.white[100]}
        />
        <H3Text
          style={[
            styles.title,
            {
              color: theme?.text.white[100],
              fontFamily: mortiseFont[700].normal,
            },
          ]}>
          {title?.orderCancelled}
        </H3Text>
        <H6Text
          style={[
            styles.description,
            {
              color: theme?.text.white[100],
              fontFamily: muliFont[400].normal,
            },
          ]}>
          {body?.cancelBodyText}
        </H6Text>
      </CenterBox>
    </Box>
  );
};

export default React.memo(CancelOrderHeader);
